import {debounce} from './utilities.js';
//import {MainMenu} from './main-menu.js';
//import {MobileMenu} from './mobile-menu.js';

let 
	mq           = window.matchMedia( '(min-width: 1024px)' ),
	element      = null,
	alwaysOpaque = false;

function header() {
	element = document.getElementById( 'site-header' );

//	if( element.classList.contains( 'c-site-header--opaque' ) ) {
//		alwaysOpaque = true;
//	}

	initEvents();
//	initMainMenu();
//	initMobileMenu();
	updateHeader();
}

function initEvents() {
	window.addEventListener( 'load', updateHeader );
	window.addEventListener( 'scroll', debounce( updateHeader ) );
	mq.addEventListener( 'change', updateHeader );
}

function initMainMenu() {
//	new MainMenu( document.querySelector( '.we-mega-menu-ul' ) );
}

function initMobileMenu() {
//	new MobileMenu( document.getElementById( 'mobile-menu' ) );
}

function updateHeader() {
	if( mq.matches ) {
		// console.log('dt');
	}
	else {
		// console.log('mb');
	}

	if( alwaysOpaque ) {
		return;
	}

	// only allow the site to be sticky if the cart isn't open
	if( 0 === window.scrollY || (document.getElementById('ajaxminicart') && document.getElementById('ajaxminicart').classList.contains('opened'))) {
		element.classList.remove( 'c-site-header--sticky' );
		
		if( ! alwaysOpaque ) {
			element.classList.remove( 'c-site-header--opaque' );
		}
	}
	else {
		element.classList.add( 'c-site-header--sticky' );
		
		if( ! alwaysOpaque ) {
			element.classList.add( 'c-site-header--opaque' );
		}
	}
}

export {header};
